import { render, staticRenderFns } from "./ContestInstructions.vue?vue&type=template&id=6a163e7a&scoped=true&"
import script from "./ContestInstructions.vue?vue&type=script&lang=js&"
export * from "./ContestInstructions.vue?vue&type=script&lang=js&"
import style0 from "./ContestInstructions.vue?vue&type=style&index=0&id=6a163e7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a163e7a",
  null
  
)

export default component.exports